import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { useComponentConfigClient } from './componentConfig.client';
import PageLayout from '../components/PageLayout';
import { Tabs } from '../components/Tabs';
import MonitoringTab from './MonitoringTab';
import ConfigurationTab from './ConfigurationTab';
import ExamplesTab from './ExamplesTab';
import { Activity, Settings, Cpu, FlaskConical } from 'lucide-react';
const TYPE_COLORS = {
    audio: 'bg-purple-100 text-purple-700',
    file: 'bg-blue-100 text-blue-700',
    camera: 'bg-green-100 text-green-700',
    chatbot: 'bg-orange-100 text-orange-700',
};
const TYPE_LABELS = {
    audio: 'Audio',
    file: 'File',
    camera: 'Camera',
    chatbot: 'Chatbot',
};
const ComponentConfigPage = () => {
    const { componentId } = useParams();
    const navigate = useNavigate();
    const client = useComponentConfigClient();
    const [component, setComponent] = useState(null);
    const [error, setError] = useState();
    const [activeTab, setActiveTab] = useState('monitoring');
    useEffect(() => {
        if (!componentId)
            return;
        client
            .getComponent(componentId)
            .then(setComponent)
            .catch(() => setError('Component not found or failed to load.'));
    }, [componentId]);
    if (!component && !error) {
        return (React.createElement("div", { className: "flex items-center justify-center h-screen text-gray-400" },
            React.createElement(Icon, { name: "spinner", loading: true }),
            " Loading..."));
    }
    const tabs = component
        ? [
            {
                id: 'monitoring',
                label: 'Monitoring',
                icon: Activity,
                description: 'Interaction logs and latency metrics',
                content: React.createElement(MonitoringTab, { componentId: component.componentId }),
            },
            {
                id: 'configuration',
                label: 'Configuration',
                icon: Settings,
                description: 'Settings and schema enforcement',
                content: (React.createElement(ConfigurationTab, { component: component, onComponentUpdated: setComponent })),
            },
            {
                id: 'examples',
                label: 'Fine-tuning',
                icon: FlaskConical,
                description: 'Labeled examples for agent fine-tuning',
                content: (React.createElement(ExamplesTab, { component: component, onComponentUpdated: setComponent })),
            },
        ]
        : [];
    return (React.createElement(PageLayout, { title: component?.name || componentId || 'Component', subtitle: component
            ? `ID: ${component.componentId}`
            : undefined, icon: React.createElement(Cpu, { className: "w-7 h-7 text-gray-700" }), error: error, showBackButton: true, onBackClick: () => navigate('/components'), containerClassName: "flex flex-col w-full min-h-screen bg-gray-50", contentClassName: "flex-1 bg-gray-50 p-6", headerActions: component ? (React.createElement("span", { className: `inline-block px-2.5 py-1 rounded text-sm font-medium ${TYPE_COLORS[component.componentType]}` }, TYPE_LABELS[component.componentType])) : undefined }, component && (React.createElement("div", { className: "bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" },
        React.createElement(Tabs, { tabs: tabs, activeTab: activeTab, onTabChange: setActiveTab })))));
};
export default ComponentConfigPage;
